import { priceComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';

const WithBaggageItineraryBuilder = () => {
  let withBaggagePosition;
  let withBaggage = {
    price: {
      amount: Infinity,
    },
  };
  return {
    add(itinerary, position) {
      const { hasCheckInBaggage } = itinerary;
      if (hasCheckInBaggage && priceComparator(itinerary, withBaggage) < 0) {
        withBaggage = itinerary;
        withBaggagePosition = position;
      }
    },
    build() {
      return createBestItineraryData(
        'withBaggage',
        withBaggage,
        withBaggagePosition
      );
    },
  };
};

export default WithBaggageItineraryBuilder;
